import { useSession } from "@/services/auth0/session";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export const useSendPasswordResetEmail = ({
  isCustomer = false,
  onSuccess,
}: {
  isCustomer?: boolean;
  onSuccess?: () => void;
}) => {
  const { token } = useSession();
  return useMutation({
    mutationFn: async (userId: string) => {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/api/v1/users/${userId}/send-password-reset-email${
          isCustomer ? "-customer" : ""
        }`,
        {
          userId,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
